
import React, { useEffect, useState } from 'react'
import { useScrollToTop } from '../../../common/useScrollToTop';
import isEqual from 'lodash/isEqual';

const BackToTopComponent = (props) => {
    const [display, setDisplay] = useState('');
    const setScrollToTop = useScrollToTop(false);
    useEffect(() => {
      let backToTopIcon = document.getElementById('backtoTop')
      if(backToTopIcon){
        backToTopIcon.addEventListener('click', scrollUp)
      }
  
      return function cleanup() {
        // componentWillUnmount
      }
    }, [])
    
  
    function scrollUp () {
      setScrollToTop(true);
    }
    useEffect(() => {
        setDisplay(props.isDisplay ? 'display' : '')
    }, [props.isDisplay])

    let clazzName = `backtoTop ${display}`
    
    return  (
      <div className={clazzName} id="backtoTop" title="Back to Top">
      </div>
    )
}

function preventRender(prevProps, nextProps) {
  return isEqual(prevProps.isDisplay, nextProps.isDisplay);
}
export default React.memo(BackToTopComponent, preventRender) 


// WEBPACK FOOTER //
// ./src/app/components/CompactView/BackToTopComponent/index.js